<template>
  <div class="popup_overlay px-4">
    <div class="custom_dialog rounded-xl" style="width: 480px;">
      <!-- Header -->
      <div class="bg-primary flex p-3 text-center justify-center sticky top-0 z-20">
        <div class="font-medium text-white heading-3">Active Session Detected</div>
      </div>

      <div class="p-6">
        <p class="heading-4 text-center mb-6 text-black">
          You have an active login session in another device. Click 'Login here' to log in to this device and log out from the other device.
        </p>

        <div class="flex justify-end gap-3">
          <Button
            :btnSize="'medium'"
            :textColor="'text1'"
            :btnColor="'white'"
            :btnText="'Cancel'"
            @buttonAction="$emit('cancel')"
          />
          <Button
            :btnSize="'medium'"
            :textColor="'white'"
            :btnColor="'primary'"
            :btnText="'Login Here'"
            @buttonAction="$emit('forceLogin')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/View/components/globalButton.vue'

export default {
  name: 'LoginConflictDialog',
  components: { Button },
  emits: ['cancel', 'forceLogin']
}
</script>
